import Accommodate from "./components/Blocks/Accommodate/Accommodate";
import Challenging from "./components/Blocks/Challenging/Challenging";
import CompetitiveAdvantages from "./components/Blocks/CompetitiveAdvantages/CompetitiveAdvantages";
import Header from "./components/Blocks/Header/Header";
import Intro from "./components/Blocks/Intro/Intro";
import MissionVision from "./components/Blocks/MissionVision/MissionVision";
import Notion from "./components/Blocks/Notion/Notion";
import Purpose from "./components/Blocks/Purpose/Purpose";
import Reason from "./components/Blocks/Reason/Reason";
import Service from "./components/Blocks/Service/Service";
import Sharing from "./components/Blocks/Sharing/Sharing";
import Support from "./components/Blocks/Support/Support";
import Vision from "./components/Blocks/Vision/Vision";
import styles from './LandingPagePipFarm.module.scss';

const PipFarm = () => {
  return (
    <div className={styles.pipFarmContainer}>
      <Header />
      <div className={styles.pipFarmContainer__wrapper}>
        <Intro />
        <Purpose />
        <Notion />
        <CompetitiveAdvantages />
        <Reason />
        <Sharing />
        <Challenging />
        <MissionVision />
        <Service />
        <Accommodate />
        <Support />
        <Vision />
      </div>
    </div>
  );
};
export default PipFarm;
